import {
  AutoComplete,
  Button,
  Form,
  Input,
  InputNumber,
  Modal,
  PaginationProps,
  Row,
  Select,
  Space,
  Table,
  Typography,
  message,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { columns, resultOptionAnalysis } from "./ResultsAnalysis.config";
import Notification from "components/common/notification/notification";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { analysisService } from "api";
import moment from "moment";
import { setCallApi, setNguoiDuyetXN } from "redux/reducer/reduxCommon";
import { setData } from "redux/reducer/pending";
import "./ResultsAnalysis.scss";
import { el } from "date-fns/locale";
import TableInputAdd from "./TableInputAdd/TableInputAdd";
import e from "cors";

const ResultsAnalysis = ({ isShowModal, handleOk, handleCancel }) => {
  const [dataModal, setDataModal] = useState([]);
  const [formData] = Form.useForm();
  const [listCS, setListCS] = useState([]);
  const idChiDinhXN = useAppSelector((state) => state.reduxCommon.id2);
  const dispatch = useAppDispatch();
  const [userSubmit, setUserSubmit] = useState("Ths Đậu Trung Hiếu");
  const [idMBP, setIdMBP] = useState(null);
  const thoiGianLayMau = useAppSelector(
    (state) => state.reduxCommon.thoiGianLayMau
  );
  const inputRef = useRef(null);
  // const [nextRef, setNextRef] = useState();

  useEffect(() => {
    if (isShowModal) {
      handleOnGetListById();
      getDataCS();
    }
  }, [isShowModal]);

  useEffect(() => {
    formData.setFieldsValue({
      formTable: dataModal,
    });
  }, [dataModal]);

  formData.setFieldsValue({
    formTable: dataModal,
    nameDoctor: userSubmit,
  });

  const handleOnGetListById = async () => {
    try {
      const res = await analysisService.getListKetQuaXN(idChiDinhXN);
      const newData = res.data.map((item) => ({
        id: item.id,
        label: item.maMayXetNghiem,
        value: item.tenChiSo,
        donViTinh: item.donViTinh,
        chiSoBinhThuong: item.chiSoBinhThuong,
      }));

      const dataTable = res.data.map((item, index) => {
        return {
          key: index,
          tenXetNghiem: item.tenNhomXetNghiem,
          children: item.cdxnDtos.map((e, idx) => {
            return {
              key: `${e.tenXetNghiem}${e.id}${idx}`,
              id: e.id,
              tenXetNghiem: e.tenXetNghiem,
              children: e.ketQua.map((i) => {
                return {
                  ...i,
                  key: `${i.tenChiSoXetNghiem}${i.id}${
                    Math.floor(Math.random() * (9999999 - 1 + 1)) + 1
                  }`,
                  tenXetNghiem: i.tenChiSoXetNghiem,
                  lanChay: i.lanChay ? i.lanChay : 1,
                };
              }),
            };
          }),
        };
      });
      // setListCS(newData);
      setDataModal(dataTable);
    } catch (error) {
      message.error("Đã xảy ra lỗi khi lấy danh sách chỉ số theo phiếu");
    }
  };

  const getDataCS = async () => {
    try {
      const res = await analysisService.getListCategoryIndexAnalysis();
      // console.log("list chỉ số all", res);
      const newData = res.data.map((item) => ({
        id: item.id,
        key: item.id,
        label: item.maMayXetNghiem,
        value: item.tenChiSo,
        donViTinh: item.donViTinh,
        chiSoBinhThuong: item.chiSoBinhThuong,
      }));

      setListCS(newData);
    } catch (error) {
      message.error("Đã xảy ra lỗi khi lấy danh sách chỉ số");
    }
  };

  const onFinish = async (value) => {
    const newData = [];

    dataModal.forEach((item) => {
      const tenNhomXetNghiem = item.tenXetNghiem;
      const cdxnDtos = item.children.map((child) => {
        return {
          id: child.id,
          idPhieuXetNghiem: idChiDinhXN,
          tenXetNghiem: child.tenXetNghiem,
          ketQua: child.children.map((subChild) => {
            return {
              // id: null,
              idChiSoXetNghiem: subChild.idChiSoXetNghiem,
              tenChiSoXetNghiem: subChild.tenChiSoXetNghiem,
              idChiDinhXetNghiem: child.idChiDinhXetNghiem,
              giaTri:
                subChild.tenChiSoXetNghiem === "UBG (UROBILINOGEN)"
                  ? subChild.giaTri == "" || !subChild.giaTri
                    ? "Normal"
                    : subChild.giaTri
                  : subChild.giaTri,
              giaTriBinhThuong: subChild.giaTriBinhThuong,
              donViTinh: subChild.donViTinh,
              lanChay: subChild.lanChay,
            };
          }),
        };
      });

      newData.push({
        tenNhomXetNghiem,
        cdxnDtos,
      });
    });

    await saveResult(newData);
    dispatch(setCallApi());
    handleCancel();
    // handleOnGetListById()
  };

  const saveResult = async (body) => {
    try {
      const response = await analysisService
        .saveListKetQuaXN(body)
        .then((res) => {
          Notification("success", "Lưu thành công");
          setData;
        });
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lưu");
    }
    handleOnGetListById();
  };
  const autoCompleteRefs = useRef([]);

  columns.map((recordFather, rowIndex) => {
    if (recordFather.dataIndex == "tenXetNghiem") {
      recordFather.render = (text, record: any, index) => {
        const isParent = record.children;
        if (isParent) {
          return (
            <span
              style={
                isParent
                  ? { fontWeight: "bold", textDecoration: "underline" }
                  : {}
              }
            >
              {text}
            </span>
          );
        } else {
          return <div>{text}</div>;
        }
      };
    }

    if (recordFather.dataIndex == "giaTri") {
      recordFather.render = (text, record: any, index) => {
        const isParent = record.children;
        if (isParent) {
          return (
            <span
              style={
                isParent
                  ? { fontWeight: "bold", textDecoration: "underline" }
                  : {}
              }
            ></span>
          );
        }
        // else if ()
        else {
          return (
            <Form.Item>
              <AutoComplete
                value={checkValueOption(record.tenXetNghiem, text)}
                options={checkResultOption(record.tenXetNghiem)}
                onChange={(value) => {
                  const newDataModal = [...dataModal];
                  newDataModal.forEach((item) => {
                    item.children.forEach((ite) => {
                      ite.children.forEach((items, idx) => {
                        index == idx && record.key == items.key
                          ? (items.giaTri = value)
                          : items;
                      });
                    });
                  });
                  setDataModal(newDataModal);
                }}
              >
                <Input
                  style={{ border: "1px solid #d9d9d9" }}
                  ref={inputRef}
                  onKeyPress={handleChangeEnter}
                />
              </AutoComplete>
            </Form.Item>
          );
        }
      };
    }
  });

  const handleChangeEnter = async (e) => {
    //id ô đầu tiên focus
    const originalId = await inputRef.current.input.id;
    //Lấy ra số id của ô đó
    const currentIdInput = await originalId.split("_")[2];
    //thay thế bằng id ô tiếp theo
    const replacedString = await originalId
      .replace(currentIdInput, parseInt(currentIdInput) + 1)
      .toString();
    //lấy ra dom của ioo tiếp
    const nextFocus = document.getElementById(replacedString);
    if (e.key === "Enter") {
      nextFocus?.focus();
    }
  };

  const checkValueOption = (name, value) => {
    if (name == "UBG (UROBILINOGEN)") {
      return "Normal";
    } else {
      return value;
    }
  };

  const checkResultOption = (name) => {
    const resultOption = resultOptionAnalysis.find(
      (option) => option.name === name
    );
    if (resultOption) {
      return resultOption.option;
    } else {
      return null;
    }
  };

  const handleOnSubmit = async () => {
    const data = {
      id: idChiDinhXN,
      nguoiDuyetKetQua: userSubmit,
      thoiGianTraKetQua: moment().format(),
    };
    try {
      const response = await analysisService
        .submitAnalysisResult(data)
        .then((res) => {
          Notification("success", "Duyệt thành công");
        });
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi duyệt");
    }
    handleCancel();
    // getResultAnalysis();
    handleOnGetListById();
  };

  const dataTable = [
    { id: 1, header1: "A1", header2: "B1", header3: "C1" },
    { id: 2, header1: "A2", header2: "B2", header3: "C2" },
    { id: 3, header1: "A3", header2: "B3", header3: "C3" },
    { id: 4, header1: "A4", header2: "B4", header3: "C4" },
    { id: 5, header1: "A5", header2: "B5", header3: "C5" },
  ];

  const groupedData = [];
  let group = [];
  dataTable.forEach((item, index) => {
    group.push(item);
    if ((index + 1) % 3 === 0 || index === dataTable.length - 1) {
      groupedData.push(group);
      group = [];
    }
  });

  const handleOnChangeMBP = (e) => {
    setIdMBP(e.target.value);
  };

  const getDataMachine = async (id) => {
    try {
      const response = await analysisService
        .getDataMachineAnalysis(idChiDinhXN, id, thoiGianLayMau)
        .then((res) => {
          const dataTable = res.data.map((item, index) => {
            return {
              key: index,
              tenXetNghiem: item.tenNhomXetNghiem,
              children: item.cdxnDtos.map((e, idx) => {
                return {
                  key: `${e.tenXetNghiem}${e.id}${idx}`,
                  id: e.id,
                  tenXetNghiem: e.tenXetNghiem,
                  children: e.ketQua.map((i) => {
                    return {
                      ...i,
                      key: `${i.tenChiSoXetNghiem}${i.id}${
                        Math.floor(Math.random() * (9999999 - 1 + 1)) + 1
                      }`,
                      tenXetNghiem: i.tenChiSoXetNghiem,
                    };
                  }),
                };
              }),
            };
          });
          setDataModal(dataTable);
        });
    } catch (error) {}
  };

  const handleOnGetResult = () => {
    if (!thoiGianLayMau) {
      Notification(
        "warning",
        "Vui lòng nhập thời gian lấy mẫu để lấy kết quả xét nghiệm"
      );
      return;
    }
    getDataMachine(idMBP);
  };

  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  const expandAllRows = () => {
    const keys = [];

    const expandKeys = (data) => {
      data.forEach((item) => {
        keys.push(item.key);
        if (item.children) {
          expandKeys(item.children);
        }
      });
    };
    expandKeys(dataModal);
    setExpandedRowKeys(keys);
  };

  useEffect(() => {
    expandAllRows();
  }, [isShowModal, idChiDinhXN, dataModal]);

  useEffect(() => {
    dispatch(setNguoiDuyetXN(userSubmit));
  }, [userSubmit]);

  return (
    <Modal
      title="Kết quả xét nghiệm"
      centered
      open={isShowModal}
      onCancel={handleCancel}
      width={"80%"}
      className="modal-tab-pay"
      footer=""
    >
      <div className="table-results">
        <Row justify={"end"} style={{ margin: "0px 0px 15px 0px" }}>
          <Space>
            <Typography.Text strong>Nhập mã bệnh phẩm</Typography.Text>
            <Input placeholder="Nhập" onChange={handleOnChangeMBP}></Input>
            <Button
              type="primary"
              className="btn-sub"
              onClick={handleOnGetResult}
            >
              Lấy kết quả
            </Button>
          </Space>
        </Row>
        <Form form={formData}>
          <Form.Item name={"formTable"}>
            <TableInputAdd
              data={dataModal}
              column={columns}
              setData={setDataModal}
              pagination={false}
              defaultExpandAllRows={true}
              expandedRowKeys={expandedRowKeys}
              expandable={{
                expandIcon: () => null,
              }}
            ></TableInputAdd>
          </Form.Item>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "16px",
            }}
          >
            <Space>
              <span style={{ paddingRight: "30px" }}>Bác sĩ duyệt</span>
              <Input
                placeholder="Nhập"
                value={userSubmit}
                style={{ width: "203px" }}
                onChange={(e) => {
                  let value = e.target.value;
                  setUserSubmit(value);
                }}
              />
            </Space>
            <div>
              <Space>
                <Button
                  key="cancel"
                  type="primary"
                  danger
                  onClick={handleCancel}
                >
                  Huỷ bỏ
                </Button>
                <Form.Item>
                  <Button key="submit" type="primary" onClick={onFinish}>
                    Lưu lại
                  </Button>
                </Form.Item>
                <Button type="primary" onClick={handleOnSubmit}>
                  Duyệt
                </Button>
              </Space>
            </div>
          </div>
        </Form>
      </div>
    </Modal>
  );
};

export default ResultsAnalysis;
